import {
    getPatternByDeviceType,
    rowNames
} from '../../news-feed/js/row-patterns';

export const getPattern = (totalItems, deviceType) => {
    switch (totalItems) {
        case 1:
            return [
                getPatternByDeviceType(rowNames.NARROW, deviceType)
            ];
        case 2:
            return [
                getPatternByDeviceType(rowNames.TWO_THIRDS_AND_ONE_THIRD, deviceType)
            ];
        default:
            return [
                getPatternByDeviceType(rowNames.TRIPLE_ONE_THIRD, deviceType)
            ];
    }
};
